// Perfil de sesión en memoria para la UI. RBAC y datos personales no se guardan en cookies del cliente.
// Las cookies HttpOnly (refresh/MFA) las gestiona el servidor; los permisos los exige el API.
import {
  clearSessionProfile,
  setSessionProfileFromLogin,
  mergeSessionProfile,
  loadSessionField
} from './sessionProfileStore'
import { purgeSessionCookiesOnLogin } from './purgeSessionCookiesOnLogin'
import { saveRbacToProfile } from './sessionRbac'

export function isMfaEnabled() {
  const value = loadSessionField('mfa_enabled')
  return value === true || value === 'true'
}

export function setMfaEnabledCookie(enabled) {
  mergeSessionProfile({ mfa_enabled: enabled })
}

export function isSecurityConfigured() {
  const value = loadSessionField('security_configured')
  if (value === undefined || value === null) return false
  return value === true || value === 'true'
}

export function setSecurityConfiguredCookie(configured) {
  mergeSessionProfile({ security_configured: configured })
}

export function saveSessionCookies(payload = {}, { email } = {}) {
  setSessionProfileFromLogin(payload, { email })
  saveRbacToProfile({
    rbac_permissions: payload.rbac_permissions,
    rbac_roles: payload.rbac_roles,
    rbac_is_admin: payload.rbac_is_admin,
    can_manage_rbac: payload.can_manage_rbac,
    warehouse_uid: payload.warehouse_uid,
    warehouse_name: payload.warehouse_name
  })
  purgeSessionCookiesOnLogin()
}

export function clearSessionCookies() {
  clearSessionProfile()
  purgeSessionCookiesOnLogin()
}

export function hasSessionUser(payload) {
  if (!payload || typeof payload !== 'object') return false
  const hasIdentity =
    payload.id != null ||
    [payload.email, payload.user_email].some(
      (value) => typeof value === 'string' && value.trim().length > 0
    )
  if (!hasIdentity) return false

  if (payload.rbac_is_admin) return true
  if (Array.isArray(payload.rbac_roles) && payload.rbac_roles.length > 0) return true
  if (Array.isArray(payload.rbac_permissions) && payload.rbac_permissions.length > 0) return true
  return payload.id != null
}

export { loadSessionField } from './sessionProfileStore'
